import { createV3Queries } from "@query/utils/createV3Queries";
import { invoiceRowsApi } from "@api";

/**
 * v3 registry for the payee-seat invoice search rows
 * (`GET /v3/search/invoice-rows`) — the denormalized, materialized row that
 * backs the invoicing dashboard list/table. This is the v3 twin of the v1
 * search-service `/search/invoice-row`: cursor pagination + the legacy filter
 * surface (search string, raw `status`, payer/payee approval + review status,
 * due date, event timestamps, engagement/payer ids), returning an `InvoiceRow`
 * that carries the columns the table renders plus a `summary`
 * (`{ count, amountTotal }`) that replaces the separate v1 summary request.
 */
export const queriesInvoiceRows = createV3Queries(
  "invoiceRowsApi",
  invoiceRowsApi
);
